
const Loading = () => {
   
    return (
        <div style ={{
            color:"#FFF",
            fontSize:"20pt",
            width:"100%",
            height:"800px",
        }}> 
            <p style={{position: "absolute",
            top: "50%",
            left: "47%"}}>Loading...</p>
        </div>
    );
  }

  export default Loading;